module.exports = __webpack_public_path__ + "static/85-b95b2d0c524077a9a0fddd1bd515adb2.png";